<template>
  <div class="nkn-product">
    <div class="body-container">
      <div class="common-title">{{$t('home.communityDApp.title')}}</div>
      <div class="nkn-product-content">
        <div class="row flex justify-center">
          <div class="col-xs-12 col-sm-12 col-md-6 pa-0">
            <div class="flex shrink justify-start" style="flex-wrap: nowrap">
              <a
                :href="langTo('/nMobile/')"
                target="_blank"
                style="padding:8px; flex-shrink: 0; width: 80px;height: 80px;"
              >
                <img
                  v-lazy="'/static/img/developer/dApp/nMobile.png'"
                  class="pic-dapp"
                  style="width: 100%;"
                />
              </a>
              <div class="flex column">
                <span>
                  <a
                    :href="langTo('/nMobile/')"
                    target="_blank"
                    class="link"
                  >{{$t('home.communityDApp.nMobile.title')}}</a>
                </span>
                <span v-html="$t('home.communityDApp.nMobile.text')"></span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 pa-0">
            <div class="flex shrink justify-start" style="flex-wrap: nowrap">
              <a
                :href="$t('home.communityDApp.dChat.url')"
                target="_blank"
                style="padding:8px; flex-shrink: 0; width: 80px;height: 80px;"
              >
                <img
                  v-lazy="'/static/img/developer/dApp/dchat.png'"
                  class="pic-dapp"
                  style="width:100%;"
                />
              </a>
              <div class="flex column">
                <span>
                  <a
                    :href="$t('home.communityDApp.dChat.url')"
                    target="_blank"
                    class="link"
                  >{{$t('home.communityDApp.dChat.title')}}</a>
                </span>
                <span>{{$t('home.communityDApp.dChat.text')}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row flex justify-center">
          <div class="col-xs-12 col-sm-12 col-md-6 pa-0">
            <div class="flex justify-start" style="flex-wrap: nowrap;flex-shrink: 0;">
              <a
                :href="$t('home.communityDApp.nFtp.url')"
                target="_blank"
                class="link"
                style="flex-shrink: 0;"
              >
                <img
                  v-lazy="'/static/img/developer/dApp/d-ftp.png'"
                  class="pic-dapp-dftp"
                  style="width: 80px;height: 80px;"
                />
              </a>
              <div class="flex column">
                <span>
                  <a
                    :href="$t('home.communityDApp.nFtp.url')"
                    target="_blank"
                    class="link"
                  >{{$t('home.communityDApp.nFtp.title')}}</a>
                </span>
                <span>{{$t('home.communityDApp.nFtp.text')}}</span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 pa-0">
            <div class="flex justify-start" style="flex-wrap: nowrap;">
              <a
                :href="$t('home.communityDApp.nShell.url')"
                target="_blank"
                class="link"
                style="flex-shrink: 0;"
              >
                <img
                  v-lazy="'/static/img/developer/dApp/nsh.png'"
                  class="pic-dapp-nsh"
                  style="width: 80px;height: 80px;"
                />
              </a>
              <div class="flex column">
                <span>
                  <a
                    :href="$t('home.communityDApp.nShell.url')"
                    target="_blank"
                    class="link"
                  >{{$t('home.communityDApp.nShell.title')}}</a>
                </span>
                <span>{{$t('home.communityDApp.nShell.text')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DappModule from "@/components/developer/plugins/dAppModule";

export default {
  components: {
    DappModule
  },
  methods: {
    langTo(path) {
      let root = "";
      if (!!this.$route.params.lang) {
        root = `/${this.$route.params.lang}`;
      }
      return `${root}${path}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.nkn-product {
  padding: 4rem 0;
  @media screen and (max-width: 768px) {
    padding: 0;
  }

  &-content {
    margin-top: 2rem;
    margin-left: 2rem;
    margin-right: 2rem;

    @media screen and (max-width: 992px) {
      margin-left: 10rem;
    }
    @media screen and (max-width: 900px) {
      margin-left: 8rem;
    }
    @media screen and (max-width: 800px) {
      margin-left: 6rem;
    }
    @media screen and (max-width: 768px) {
      margin: 0;
      .row {
        width: 60%;
        margin-left: auto !important;
        margin-right: auto !important;
      }
    }
    @media screen and (max-width: 550px) {
      .row {
        width: 100%;
        margin-left: auto !important;
        margin-right: auto !important;
      }
    }

    .link-module {
      margin-bottom: 3rem;

      ul {
        padding-left: 1rem;
        padding-right: 1rem;
      }

      @media screen and (max-width: 768px) {
        margin-left: 1rem;
      }

      &-title {
        @include nkn-font-set(1.2rem, currentColor);
        line-height: 1.2rem;

        @media screen and (max-width: 768px) {
          margin-top: 2rem;
        }
      }

      &-text {
        @include nkn-font-set(0.7rem, currentColor);
        line-height: 1rem;
        margin-top: 1rem;
        min-height: 2.25rem;

        // @media screen and (max-width: 768px) {
        //   display: inline-block;
        // }

        i {
          flex-shrink: 0;
          vertical-align: middle;
        }

        span {
          display: inline-block;
          padding-top: 0.25rem;
          margin-left: 0.5rem;

          @media screen and (max-width: 768px) {
          }
        }

        & > a {
          display: flex;
          align-items: center;

          &:hover {
            color: #1791f2 !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/nknCommunityDApps.vue